export default __webpack_public_path__ + "static/media/CodingwithMinecraft.90d077ef.png";